import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type ScormOverview } from "../../types/models";

export interface OverviewState extends FetchingItemsState<ScormOverview> {
  selected: number[];
}

export const initialState: OverviewState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  selected: [],
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.SCORM,
    name: "Overview",
    namespace: ReducerNamespaceTypes.Library,
  },
  reducers: {
    setSelected: (state, action: PayloadAction<number[]>) => {
      state.selected = action.payload;
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setSelected } = slice.actions;

export default slice.reducer;
